import React from 'react';
import Footer from './sections/Footer.js';
import phone_img from './assets/here4u_phone_splash.png';
import arrow from './assets/arrow redirect.png';
import arrowBlack from './assets/arrow redirect black.png';
import No1 from './assets/1.png';
import No2 from './assets/2.png';
import No3 from './assets/3.png';
import No4 from './assets/4.png';
import betterHelp from './assets/better_help.png';
import './Home.css';
import LogoMenu from './sections/Menu.js';

function OverlayCard({ imageSrc, altText, text }) {
  return (
    <div className="TheApp-grid-item">
      <div className="TheApp-grid-item-overlay-wrapper">
        <img src={imageSrc} className="TheApp-grid-item-image" alt={altText} />
        <p className="TheApp-grid-item-overlay-text">{text}</p>
      </div>
    </div>
  );
}

function Home() {
  const steps = [
    {
      image: No1,
      text: "No need to create an account. Just open the app and start. 100% anonymous."
    },
    {
      image: No2,
      text: "Answer a few simple questions. The app will guide you to figure out what kind of help you’re looking for."
    },
    {
      image: No3,
      text: "Get your personalized support plan. The app builds a plan based on your answers."
    },
    {
      image: No4,
      text: "Save your plan. Download it to your device or email it to yourself for easy access."
    }
  ];

  return (
    <div className="App-container">
      <div className="App-grid">
        <LogoMenu />
        <div className="App-grid-title-row">
          <h1 className='Here4U-title'>Here4U</h1>
        </div>
        <div className="App-grid-text-row">
          <p className='Here4U-right-aligned-text'>
            Tools and connection<br/>to care for your<br/>mental health
          </p>
        </div>
        <div className="App-grid-item">
          <img src={phone_img} className="Phone-image" alt="Here4U Splash Screen" />
        </div>
      </div>
      <div className="Stats-overlap-section">
        <div className="Stats-text Stats-text-added-margin">
            <h1>1 in 2 Americans</h1>
            <p>
                Face a mental health challenge in their lifetime. 
                This means that it will almost certainly include 
                someone you love, including yourself.
            </p>            
        </div>
      </div>
      <div className="About-section">
        <h2>ABOUT</h2>
        <h1>
          Real connections.<br/>
          Real tools.
        </h1>
        <p>
          At Here4U, our mission is simple: Make Mental health 
          resources more accessible, personalized, and meaningful. 
          We are a trusted hub designed to connect people to the 
          support they need, when they need it. 
          <br/><br/>
          Whether you're a college student navigating academic stress, 
          a city resident facing daily pressures, a service member 
          adjusting to civilian life, an athlete pushing through performance 
          demands, or a professional managing work-life balance, Here4U is 
          for here for you. 
          <br/><br/>
          No concern is too small, and no challenge is too big. From self-guided 
          tools to professional services, we help you identify the options that 
          best match your unique needs. Wherever you are on your mental health 
          journey, Here4U offers a clear path forward with real connections and 
          real tools that work for real life. 
        </p>
      </div>
      <div className="TheApp-section">
        <h2>THE APP</h2>
        <h1>
          Connect now to get the help you need.
        </h1>
        <img src={phone_img} className="TheApp-image" alt="Here4U Splash Screen" />
        <div className="Arrow-link">
          <a
            href="https://thrive.here4u.care"
            className="Arrow-icon"
            target="_blank"
            rel="noreferrer noopener"
          >
              <img src={arrow} alt="Right arrow" />
          </a>
          <p className="Arrow-text">Click the Arrow</p>
        </div>
        <div className="TheApp-grid">
          {steps.map((step, index) => (
            <OverlayCard
              key={index}
              imageSrc={step.image}
              altText={`Number ${index + 1}`}
              text={step.text}
            />
          ))}
        <div className="Arrow-link">
          <a
            href="https://thrive.here4u.care"
            className="Arrow-icon"
            target="_blank"
            rel="noreferrer noopener"
          >
              <img src={arrow} alt="Right arrow" />
          </a>
          <p className="Arrow-text">Click the Arrow</p>
        </div>
        </div>
      </div>
      <div className="Partners-section">
        <h2>PARTNERS</h2>
        <h1>
          Collaboration with<br/>
          the industry's best.
        </h1>
        <img src={betterHelp} className="Partners-image" alt="Better Help" />
        <p>
          Our partners help make real support possible. These organizations are 
          leaders in their fields and bring trusted expertise to the Here4U 
          experience. Together, we create a more complete pathway to mental 
          health and well-being. We are always exploring new partnerships to 
          expand our reach and deepen the impact for those we serve.           
        </p>
      </div>
      <div className="Stats-overlap-section">
        <div className="Stats-text">
            <h1>76% of people</h1>
            <p>
                Struggle with loneliness, stress, or anxiety at least once in 
                the past year.
            </p>            
        </div>
      </div>
      <div className="About-section">
        <h2>JOIN THE CAUSE</h2>
        <h1>
          Become a partner
        </h1>
        <p>
          At Here4U, we believe that meaningful change in mental health starts 
          with collaboration. We are building a powerful network of professionals 
          and organizations dedicated to making support more accessible, inclusive, 
          and effective for everyone. 
          <br/><br/>
          Whether you provide professional services, digital wellness tools, or 
          self-guided resources, we want to hear from you. Our platform connects 
          people in need with the right solutions, which makes your work part of 
          that journey. 
          <br/><br/>
          Together, we can close the gap between those seeking help and those 
          equipped to provide it. If you are passionate about solving today’s 
          mental health challenges, reach out and explore how we can partner to 
          create lasting impact. 
        </p>
        <div className="Arrow-link">
          <a
            href="https://thrive.here4u.care"
            className="Arrow-icon"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img src={arrowBlack} alt="Right arrow" />
          </a>
          <p className="Arrow-text">Click the Arrow</p>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Home;
